import { render, staticRenderFns } from "./VoiceMessagePopup.vue?vue&type=template&id=6cffb6e9&scoped=true"
import script from "./VoiceMessagePopup.vue?vue&type=script&lang=js"
export * from "./VoiceMessagePopup.vue?vue&type=script&lang=js"
import style0 from "./VoiceMessagePopup.vue?vue&type=style&index=0&id=6cffb6e9&prod&scoped=true&lang=css"
import style1 from "./VoiceMessagePopup.vue?vue&type=style&index=1&id=6cffb6e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cffb6e9",
  null
  
)

export default component.exports